import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const StyleConsistencySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const StyleConsistencyContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 12px;

  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const StyleImage = styled.img<{
  $isLoading?: boolean
}>`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: 4px;

  object-fit: cover;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  transition: opacity 0.3s ease-in-out;
`

export const TextContentWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;

  .highlighted {
    font-weight: 600;
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
  }
`
export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const ThunderIcon = styled.img`
  width: 16px;
  height: 16px;
`

export const ThunderIconWrapper = styled.div`
  display: flex;
  align-items: center;
`
